const func = $target => {
	var gutter = 30,
		$header = $('header'),
		$thumbs = $target.find('.gallery-thumbs a'),
		height;

	$(window)
		.on('resize', function() {
			height = $header.height() + gutter;
			$target.css('top', height);
		})
		.trigger('resize');

	$('body').scrollspy({
		target: $target.find('.gallery-thumbs'),
		offset: height + gutter,
		method: 'offset'
	});

	$thumbs.on('click', function(e) {
		e.preventDefault();
		var $this = $(this);
		window.scroller.animateScroll($($this.attr('href')).offset().top - $header.outerHeight() - gutter);
	});
};

export default func;
